import React, { Component, Fragment } from 'react';
import autoBind from 'react-autobind';
import ToastMessage from '../ToastMessage';
const snackBarActions = {
  showSnackBar: () => {},
};

export function showSnackBar(...args) {
  snackBarActions.showSnackBar(...args);
}

const initialState = {
  toastMessage: '',
  onClose: () => {},
  showToast: false,
  variant: 'success',
};

export default class SnackBar extends Component {
  constructor(props) {
    super(props)

    this.state = initialState;
    autoBind(this);
  }

  componentDidMount(){
    snackBarActions.showSnackBar = this.showSnackBar;
  }

  showSnackBar(variant, toastMessage, close = ()=> {}){
    this.setState({
      toastMessage,
      close,
      showToast: true,
      variant,
    });
  }

  handleCloseSnackbar(cb) {  
    this.setState(initialState);
    if(cb) cb();
  }

  render() {
    const { toastMessage, close, showToast, variant } = this.state;
    return (
      <Fragment>
        <ToastMessage
          message={toastMessage}
          variant={variant}
          onClose={this.handleCloseSnackbar.bind(this,close)}
          show={showToast}
        />
      </Fragment>
    )
  }
}
